import type { ILogging } from '../../api/types/ILogging';

/**
 * inhouse 삭제할때 편하게 삭제할 목적
 */
export function getAblyOnlyLog(logging?: ILogging) {
  return logging?.ably_only_log ?? logging?.inhouse ?? {};
}
